"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionList = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var AccordionList = function (props) {
    var _a;
    var _b = (0, react_1.useState)((_a = props === null || props === void 0 ? void 0 : props.accordionList) !== null && _a !== void 0 ? _a : []), accordions = _b[0], setAccordions = _b[1];
    var _c = (0, react_1.useState)([]), isOpen = _c[0], setIsOpen = _c[1];
    var accordionRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(function () {
        if (props.accordionList)
            setAccordions(props.accordionList);
    }, [props.accordionList]);
    (0, react_1.useEffect)(function () {
        if ((accordions === null || accordions === void 0 ? void 0 : accordions.length) > 0)
            setIsOpen(new Array(accordions.length).fill(false));
    }, [accordions]);
    (0, react_1.useEffect)(function () {
        var handleToggle = function (index) {
            setIsOpen(function (prev) {
                var _a, _b;
                var state = __spreadArray([], prev, true);
                state[index] = (_b = (_a = accordionRefs.current[index]) === null || _a === void 0 ? void 0 : _a.open) !== null && _b !== void 0 ? _b : false;
                return state;
            });
        };
        accordionRefs.current.forEach(function (el, i) {
            if (el) {
                var toggleHandler_1 = function () { return handleToggle(i); };
                el.addEventListener("toggle", toggleHandler_1);
                return function () { return el.removeEventListener("toggle", toggleHandler_1); };
            }
        });
    }, [accordions]);
    var onCloseAll = function () {
        setIsOpen(Array(accordions.length).fill(false));
        accordionRefs.current.forEach(function (el) { if (el)
            el.open = false; });
    };
    return (react_1.default.createElement("div", { className: "accordion-list" },
        react_1.default.createElement("button", { className: "accordion-list__button", onClick: function () { return onCloseAll(); } }, "Lukk alle"),
        accordions.map(function (a, i) { return (react_1.default.createElement(AccordionBlock, { key: "accordion-".concat(i), Heading: a.Heading, Content: a.Content, Url: a.Url, ShowReadMoreLink: a.ShowReadMoreLink, isOpen: isOpen[i], ref: function (el) {
                return (accordionRefs.current[i] = el);
            } })); })));
};
exports.AccordionList = AccordionList;
var AccordionBlock = react_1.default.forwardRef(function (_a, ref) {
    var Heading = _a.Heading, Content = _a.Content, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, Url = _a.Url, ShowReadMoreLink = _a.ShowReadMoreLink;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("details", { className: "accordion-item", ref: ref },
            react_1.default.createElement("summary", { className: "accordion-item__trigger", "aria-expanded": isOpen },
                react_1.default.createElement("span", { className: "accordion-item__title", dangerouslySetInnerHTML: { __html: Heading !== null && Heading !== void 0 ? Heading : "" } }),
                react_1.default.createElement("span", { className: "accordion-item__icon accordion-item__icon".concat(isOpen ? "--active" : "--inactive"), "aria-hidden": true })),
            react_1.default.createElement("div", { className: "accordion-item__panel ".concat(ShowReadMoreLink ? "accordion-item__panel--truncate" : ""), dangerouslySetInnerHTML: { __html: Content !== null && Content !== void 0 ? Content : "" }, "aria-hidden": !isOpen }),
            ShowReadMoreLink && react_1.default.createElement("a", { href: Url !== null && Url !== void 0 ? Url : "#" }, "Les mer")),
        react_1.default.createElement("hr", { className: "accordion-item__divider" })));
});
var renderApp = function () {
    var _a;
    var nodeId = "index-accordion-list-root";
    var appRootNode = document.getElementById(nodeId);
    var props = {};
    if (!appRootNode) {
        console.warn("Cannot find node with ID '".concat(nodeId, "'. The React app cannot be rendered."));
        return;
    }
    try {
        var accordionListString = (_a = appRootNode.getAttribute("data-list")) !== null && _a !== void 0 ? _a : "{}";
        props.accordionList = JSON.parse(accordionListString);
    }
    catch (e) {
        console.error("Failed to parse props data", e);
    }
    react_dom_1.default.render(react_1.default.createElement(exports.AccordionList, props), appRootNode);
};
renderApp();
